function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';

class Areas extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderArea", area => {
      const _this$props = this.props,
            areaGenerator = _this$props.areaGenerator,
            areaOpacity = _this$props.areaOpacity,
            areaBlendMode = _this$props.areaBlendMode;
      const id = area.id,
            data = area.data,
            areaColor = area.color;
      const className = "area  area--" + id;
      return React.createElement("path", {
        key: id,
        d: areaGenerator(data.map(d => d.position)),
        fill: areaColor,
        fillOpacity: areaOpacity,
        strokeWidth: 0,
        className: className,
        style: {
          mixBlendMode: areaBlendMode
        }
      });
    });
  }

  render() {
    const series = this.props.series;
    return React.createElement("g", {
      className: "areas"
    }, series.slice(0).reverse().map(this.renderArea));
  }

}

export default Areas;